// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'

import Vue from 'vue'
import Router from 'vue-router'

import config from 'SrcConfig'

import { ClientJS } from 'clientjs'
import PortalVue from 'portal-vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Config from './plugins/config'
import Api from './plugins/api'
import Dir from './plugins/dir'
import directives from './plugins/directives'
import Messages from './plugins/messages'
import Meta from 'vue-meta'
import Snotify from 'vue-snotify'
import VeeValidate from 'vee-validate'
import Mixin from '@/plugins/global-mixin'
import VueCookies from 'vue-cookies'
import JsonExcel from 'vue-json-excel'
import { Plugin } from 'vue-fragment'
import DisableAutocomplete from '@/mixins/disableAutoComplete'
import FirebaseMessaging from '@/plugins/firebase-messaging'
import VueAnimateCss from 'v-animate-css'

import './registerServiceWorker'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas as solid } from '@fortawesome/free-solid-svg-icons'
import { far as regular } from '@fortawesome/free-regular-svg-icons'
import * as types from './constants/store-mutation-types'
import { SET_FIREBASE_MESSAGING_TOKEN } from './constants/store-mutation-types'
import store from './store'
import router from './router'
import { permissionsHaveNamespaces } from '@/lib/account'
import { get as getData } from '@/lib/local-storage'
import App from './App'
import firebaseMessaging from '@/firebase-messaging'
import api from '@/api'
import i18n from '@/plugins/i18n'
import browserDetect from 'vue-browser-detect-plugin'
import * as Sentry from '@sentry/vue'

// Import global components thath exported inside src/components/global.js file
import globalComponents from '@/components/global'
Object.keys(globalComponents).forEach((componentName) => {
  Vue.component(componentName, globalComponents[componentName])
})

Vue.use(PortalVue)
Vue.use(BootstrapVue)
Vue.use(Config)
Vue.use(Api)
Vue.use(Dir)
Vue.use(Messages)
Vue.use(directives)
Vue.use(Meta)
Vue.use(Snotify)
Vue.use(VeeValidate, { fieldsBagName: 'veeFields' })
Vue.use(Mixin)
Vue.use(VueCookies)
Vue.component('downloadExcel', JsonExcel)
Vue.use(Plugin)
Vue.use(DisableAutocomplete)
Vue.use(browserDetect)
Vue.use(VueAnimateCss)

if (config.firebase) Vue.use(FirebaseMessaging)

library.add(solid)
library.add(regular)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.directive('notEmpty', {
  // When the bound element is inserted into the DOM...
  update: (el) => {
    el.value = !el.value.trim().length ? null : el.value
    console.log(el.value.trim().length)
    console.log(el.value)
  }
})

// Set Account ----------------------------------------
let account = getData(types.ACCOUNT_COOKIE)
if (account) {
  store.commit(types.SET_ACCOUNT, account)
}
// ---------------------------------------------------

// Set permissions ----------------------------------------
let permissions = getData(types.PERMISSION)
if (permissions) {
  store.commit(types.SET_PERMISSION, permissions)
}
// ---------------------------------------------------

router.beforeEach((to, from, next) => {
  // Request notification permission and update notification session if needed
  if (
    store.state.$account &&
    !store.getters.firebaseMessagingToken &&
    config.firebase
  )
    if (typeof Notification !== 'undefined') {
      Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
          firebaseMessaging
            .getToken({ vapidKey: config.firebase.vapidKey })
            .then((token) => {
              store.commit(SET_FIREBASE_MESSAGING_TOKEN, token)
              api(store)
                .userAccount.updateNotificationSession(token)
                .catch((error) =>
                  console.error('error in update session token:', error)
                )
            })
        }
      })
    }
  // Check route permission based on parrent route
  if (!to.meta.auth) {
    next()
  } else {
    if (store.state.$permissions && store.state.$permissions.length) {
      if (to.meta.auth === true) {
        next()
      } else {
        const routePermission = to.matched.reduce((permissions, route) => {
          if (route.meta && route.meta.auth) permissions.push(route.meta.auth)

          return permissions
        }, [])

        if (
          routePermission.length &&
          permissionsHaveNamespaces(
            routePermission.join('.'),
            store.state.$permissions
          )
        ) {
          next()
        } else {
          next({
            path: '/access-denied',
            query: {
              redirect:
                from.path !== config.homeUrl && from.path !== '/'
                  ? from.fullPath
                  : undefined
            }
          })
        }
      }
      next()
    } else {
      if (to.fullPath !== config.homeUrl) {
        next(`/login?redirect=${to.fullPath}`)
      } else {
        next('/login')
      }
    }
  }
})

const clientJs = new ClientJS()
const fingerprint = clientJs.getCustomFingerprint(
  clientJs.getBrowserData().ua || 'NO BROWSER UA',
  clientJs.getScreenPrint() || 'NO SCREEN PRINT',
  clientJs.getCPU() || 'NO CPU',
  clientJs.isMobile() ? 'MOBILE' : 'DESKTOP'
)
store.commit(types.SET_FINGERPRINT, fingerprint)

const isWebView = navigator.userAgent.includes('wv')
store.commit(types.SET_WEB_VIEW, isWebView)
store.commit(types.SET_CLIENT_TYPE, isWebView ? 'AAW' : 'WA')

// sentry
if (config.sentry) {
  const { dsn, tracePropagationTargets } = config.sentry
  Sentry.init({
    Vue,
    dsn,
    integrations: [
      new Sentry.BrowserTracing({
        tracePropagationTargets,
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ],
    tracesSampleRate: 1.0
  })
}

new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: {
    App
  },
  beforeCreate() {
    let locale = getData(types.LOCALE_COOKIE) || config.locale
    this.$store.commit(types.SET_LOCALE, {
      value: locale,
      validator: this.$validator,
      i18n: this.$i18n
    })
  }
})
